import { render, staticRenderFns } from "./AmberResultsDataTable.vue?vue&type=template&id=1fcc212a"
import script from "./AmberResultsDataTable.vue?vue&type=script&lang=js"
export * from "./AmberResultsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports